import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userPerformanceLogsAdapter = createEntityAdapter({})

const initialState = userPerformanceLogsAdapter.getInitialState()

export const userPerformanceLogsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserPerformanceLogs: builder.query({
            query: (userId) => ({
                url: `/userPerformanceLogs/getUserPerformanceLogs/${userId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserPerformanceLogs = responseData.map(userPerformanceLog => {
                    userPerformanceLog.id = userPerformanceLog._id
                    return userPerformanceLog
                })
                return userPerformanceLogsAdapter.setAll(initialState, loadedUserPerformanceLogs)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserPerformanceLog', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserPerformanceLog', id}))
                    ]
                } else {
                    return [ { type: 'UserPerformanceLog', id: 'LIST'}]
                }
            },
        }),
        createNewUserPerformanceLog: builder.mutation({
            query: (initialPayload) => ({
                url: '/userPerformanceLogs/createNewUserPerformanceLog',
                method: 'POST',
                body: initialPayload,
            }),
            invalidatesTags: [{ type: 'UserPerformanceLog', id: 'LIST' }]
        }),
    }),
})

export const {
    useGetUserPerformanceLogsQuery,
    useCreateNewUserPerformanceLogMutation,
} = userPerformanceLogsApiSlice

// returns the query result object
export const selectUserPerformanceLogResult = userPerformanceLogsApiSlice.endpoints.getUserPerformanceLogs.select()

// create memoized selector
const selectUserPerformanceLogsData = createSelector(
    selectUserPerformanceLogResult,
    userPerformanceLogResult => userPerformanceLogResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserPerformanceLogs,
    selectById: selectUserPerformanceLogById,
    selectIds: selectUserPerformanceLogIds,
} = userPerformanceLogsAdapter.getSelectors(state => selectUserPerformanceLogsData(state) ?? initialState)